import { render, staticRenderFns } from "./GiftNews.vue?vue&type=template&id=1e7d538e&"
import script from "./GiftNews.vue?vue&type=script&lang=ts&"
export * from "./GiftNews.vue?vue&type=script&lang=ts&"
import style0 from "./GiftNews.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports